<template>
  <nav class="nav_center2" style="padding: 0; background: cadetblue">
    <ul style="list-style: none">
      <li :class="{ topmenuactive: activeTab === 'hethongcnttthainguyen' }" @click="changeTab('hethongcnttthainguyen')">
        <a id="urlhethongcnttthainguyen" href="vi/chuongtrinhtaitroxathidiem#thainguyen/hethongcnttthainguyen" style="color: white;">{{ currentLanguage.header_text_hethongCNTT15 }}</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xadiemthuy' } " @click="changeTab('Xadiemthuy')">
        <a id="urlXadiemthuy" href="vi/chuongtrinhtaitroxathidiem#thainguyen/xadiemthuy" style="color: white;">Điềm Thụy</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xaphubinh' }" @click="changeTab('Xaphubinh')"  >
        <a id="urlXaphubinh" href="vi/chuongtrinhtaitroxathidiem#thainguyen/xaphubinh" style="color: white;">Phú Bình</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xatankhanh' }" @click="changeTab('Xatankhanh')">
        <a id="urlXatankhanh" href="vi/chuongtrinhtaitroxathidiem#thainguyen/xatankhanh" style="color: white;">Tân Khánh</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xanamhoa' }" @click="changeTab('Xanamhoa')" >
        <a id="urlXanamhoa" href="vi/chuongtrinhtaitroxathidiem#thainguyen/xanamhoa" style="color: white;">Nam Hòa</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xavanhan' }" @click="changeTab('Xavanhan')" >
        <a id="urlXavanhan" href="vi/chuongtrinhtaitroxathidiem#thainguyen/xavanhan" style="color: white;">Văn Hán</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xadonghy' }" @click="changeTab('Xadonghy')" >
        <a id="urlXadonghy" href="vi/chuongtrinhtaitroxathidiem#thainguyen/xadonghy" style="color: white;">Đồng Hỷ</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xavotranh' }" @click="changeTab('Xavotranh')" >
        <a id="urlXavotranh" href="vi/chuongtrinhtaitroxathidiem#thainguyen/xavotranh" style="color: white;">Vô Tranh</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xaankhanh' }" @click="changeTab('Xaankhanh')"  >
        <a id="urlXaankhanh" href="vi/chuongtrinhtaitroxathidiem#thainguyen/xaankhanh" style="color: white;">An Khánh</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xadaiphuc' }" @click="changeTab('Xadaiphuc')" >
        <a id="urlXadaiphuc" href="vi/chuongtrinhtaitroxathidiem#thainguyen/xadaiphuc" style="color: white;">Đại Phúc</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xatancuong' }" @click="changeTab('Xatancuong')" >
        <a id="urlXatancuong" href="vi/chuongtrinhtaitroxathidiem#thainguyen/xatancuong" style="color: white;">Tân Cương</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xaquanchu' }" @click="changeTab('Xaquanchu')" >
        <a id="urlXaquanchu" href="vi/chuongtrinhtaitroxathidiem#thainguyen/xaquanchu" style="color: white;">Quân Chu</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xavanphu' }" @click="changeTab('Xavanphu')" >
        <a id="urlXavanphu" href="vi/chuongtrinhtaitroxathidiem#thainguyen/xavanphu" style="color: white;">Vạn Phú</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xatanthanh' }" @click="changeTab('Xatanthanh')" >
        <a id="urlXatanthanh" href="vi/chuongtrinhtaitroxathidiem#thainguyen/xatanthanh" style="color: white;">Tân Thành</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xakhason' }" @click="changeTab('Xakhason')" >
        <a id="urlXakhason" href="vi/chuongtrinhtaitroxathidiem#thainguyen/xakhason" style="color: white;">Kha Sơn</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xathanhcong' }" @click="changeTab('Xathanhcong')"  > 
        <a id="urlXathanhcong" href="vi/chuongtrinhtaitroxathidiem#thainguyen/xathanhcong" style="color: white;">Thành Công</a>
      </li>
    </ul>
  </nav>

  <div class="wrapper row3">
     <main class="hoc container-fluid clear bv p-0">

      <!-- Mỗi xã -->
      <div v-if="activeTab === 'hethongcnttthainguyen'" style="min-height: 500px" class="padding-top15">
        <div class="title-bai-viet" v-html="titleHtmlHethongcnttthainguyen"></div>
        <div v-html="contentHtmlHethongcnttthainguyen || 'Đang cập nhật...'"></div>
        </div>
      <div v-if="showXadiemthuy" class="padding-top15"><strong>Điềm Thụy</strong><div v-html="contentHtmlXadiemthuy || 'Đang cập nhật...'"></div></div>
      <div v-if="showXaphubinh" class="padding-top15"><strong>Phú Bình</strong><div v-html="contentHtmlXaphubinh || 'Đang cập nhật...'"></div></div>
      <div v-if="showXatankhanh" class="padding-top15"><strong>Tân Khánh</strong><div v-html="contentHtmlXatankhanh || 'Đang cập nhật...'"></div></div>
      <div v-if="showXanamhoa" class="padding-top15"><strong>Nam Hòa</strong><div v-html="contentHtmlXanamhoa || 'Đang cập nhật...'"></div></div>
      <div v-if="showXavanhan" class="padding-top15"><strong>Văn Hán</strong><div v-html="contentHtmlXavanhan || 'Đang cập nhật...'"></div></div>
      <div v-if="showXadonghy" class="padding-top15"><strong>Đồng Hỷ</strong><div v-html="contentHtmlXadonghy || 'Đang cập nhật...'"></div></div>
      <div v-if="showXavotranh" class="padding-top15"><strong>Vô Tranh</strong><div v-html="contentHtmlXavotranh || 'Đang cập nhật...'"></div></div>      
      <div v-if="showXaankhanh" class="padding-top15"><strong>An Khánh</strong><div v-html="contentHtmlXaankhanh || 'Đang cập nhật...'"></div></div>
      <div v-if="showXadaiphuc" class="padding-top15"><strong>Đại Phúc</strong><div v-html="contentHtmlXadaiphuc || 'Đang cập nhật...'"></div></div>
      <div v-if="showXatancuong" class="padding-top15"><strong>Tân Cương</strong><div v-html="contentHtmlXatancuong || 'Đang cập nhật...'"></div></div>
      <div v-if="showXaquanchu" class="padding-top15"><strong>Quân Chu</strong><div v-html="contentHtmlXaquanchu || 'Đang cập nhật...'"></div></div>
      <div v-if="showXavanphu" class="padding-top15"><strong>Vạn Phú</strong><div v-html="contentHtmlXavanphu || 'Đang cập nhật...'"></div></div>
      <div v-if="showXatanthanh" class="padding-top15"><strong>Tân Thành</strong><div v-html="contentHtmlXatanthanh || 'Đang cập nhật...'"></div></div>
      <div v-if="showXakhason" class="padding-top15"><strong>Kha Sơn</strong><div v-html="contentHtmlXakhason || 'Đang cập nhật...'"></div></div>
      <div v-if="showXathanhcong" class="padding-top15"><strong>Thành Công</strong><div v-html="contentHtmlXathanhcong || 'Đang cập nhật...'"></div></div>
    </main>
  </div>
</template>
<script scoped>
import { languages } from "@/components/languages";
import { apiChiTietBaiViet } from "@/components/listService";
import axios from "axios";


export default {
  components: {

  },
  data() {
    return {
      activeTab: 'hethongcnttthainguyen',

      currentLanguage: languages.vi,
      lang: "",
      base64: "",
      base64Title: "",

      showXatankhanh: false,
      showXanamhoa: false,
      showXaphubinh: false,
      showCopilot: false,
      showGrok: false,
      showXavanhan: false,
      showManus: false,
      showXadiemthuy: false,
      showXadonghy: false,
      showXavotranh: false,
      showUngDungAI: false,
      showXathanhcong: false,
      showXaankhanh: false,
      showXadaiphuc: false,
      showXatancuong: false,
      showXaquanchu: false,
      showXavanphu: false,
      showXatanthanh: false,
      showXakhason: false,
      showHethongcnttthainguyen: false,

      titleHtmlAITaiLopHoc: "",
      contentHtmlAITaiLopHoc: "",
      titleHtml: "",
      contentHtml: "",
      titleHtmlTruongTaiTro: "",
      contentHtmlTruongTaiTro: "",
      titleHtmlTH: "",
      contentHtmlTH: "",
      titleHtmlTHCS: "",
      contentHtmlTHCS: "",
      titleHtmlTHPT: "",
      contentHtmlTHPT: "",
      titleHtmlLienHe: "",
      contentHtmlLienHe: "",
      titleHtmlLienCap: "",
      contentHtmlLienCap: "",

      titleHtmlXadiemthuy: "",
      titleHtmlXatankhanh: "",
      titleHtmlXanamhoa: "",
      titleHtmlXaphubinh: "",
      titleHtmlCopilot: "",
      titleHtmlGrok: "",
      titleHtmlXavanhan: "",
      titleHtmlXadonghy: "",
      titleHtmlXavotranh: "",
      titleHtmlManus: "",
      titleHtmlUngDungAI: "",
      titleHtmlXathanhcong: "",
      titleHtmlXaankhanh: "",
      titleHtmlXadaiphuc: "",
      titleHtmlXatancuong: "",
      titleHtmlXaquanchu: "",
      titleHtmlXavanphu: "",
      titleHtmlXatanthanh: "",
      titleHtmlXakhason: "",
titleHtmlHethongcnttthainguyen: "",
conttentHtmlHethongcnttthainguyen: "",

      contentHtmlXadiemthuy: "",
      contentHtmlXatankhanh: "",
      contentHtmlXanamhoa: "",
      contentHtmlCopilot: "",
      contentHtmlXaphubinh: "",
      contentHtmlGrok: "",
      contentHtmlXavanhan: "",
      contentHtmlXadonghy: "",
      contentHtmlXavotranh: "",
      contentHtmlManus: "",
      contentHtmlUngDungAI: "",
      contentHtmlXathanhcong: "",

      contentHtmlXaankhanh: "",
      contentHtmlXadaiphuc: "",
      contentHtmlXatancuong: "",
      contentHtmlXaquanchu: "",
      contentHtmlXavanphu: "",
      contentHtmlXatanthanh: "",
      contentHtmlXakhason: "",


    };
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.isMenuVisible = false;
    } else {
      this.isMenuVisible = true;
    }
    if (!this.hasMounted) {
      this.hasMounted = true;
      this.lang = localStorage.getItem("languages")   || "vi";
      // this.performPostRequest("1755075075179y5bWE", "Xatankhanh", this.lang);
document.getElementById("urlhethongcnttthainguyen").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/hethongcntt");
      document.getElementById("urlXadiemthuy").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/xadiemthuy");
      document.getElementById("urlXaphubinh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/xaphubinh");
      document.getElementById("urlXanamhoa").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/xanamhoa");
      document.getElementById("urlXatankhanh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/xatankhanh");
      document.getElementById("urlXavanhan").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/xavanhan");
      document.getElementById("urlXadonghy").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/xadonghy");
      document.getElementById("urlXavotranh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/xavotranh");
      document.getElementById("urlXathanhcong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/xathanhcong");
      document.getElementById("urlXaankhanh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/xaankhanh");
      document.getElementById("urlXadaiphuc").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/xadaiphuc");
      document.getElementById("urlXatancuong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/xatancuong");
      document.getElementById("urlXaquanchu").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/xaquanchu");
      document.getElementById("urlXavanphu").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/xavanphu");
      document.getElementById("urlXatanthanh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/xatanthanh");
      document.getElementById("urlXakhason").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/xakhason");


      // document.getElementById("urlManus").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/manus/");
      // document.getElementById("urlGrok").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/grok/");
      // document.getElementById("urlCopilot").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/copilot/");




      let fragmentTab = window.location.hash.substring(1);
            if (fragmentTab.endsWith("/")) {
                fragmentTab = fragmentTab.slice(0, -1);
            }
      // console.log("fragmentTab " + fragmentTab);

      if (fragmentTab === "thainguyen/xadiemthuy") {
        this.changeTab("Xadiemthuy");
      } else if (fragmentTab === "thainguyen/xaphubinh") {
        this.changeTab("Xaphubinh");
      } else if (fragmentTab === "thainguyen/xanamhoa") {
        this.changeTab("Xanamhoa");
      } else if (fragmentTab === "thainguyen/xatankhanh") {
        this.changeTab("Xatankhanh");
      } else if (fragmentTab === "thainguyen/copilot") {
        this.changeTab("Copilot");
      } else if (fragmentTab === "thainguyen/grok") {
        this.changeTab("Grok");
      } else if (fragmentTab === "thainguyen/xavanhan") {
        this.changeTab("Xavanhan");
      } else if (fragmentTab === "thainguyen/manus") {
        this.changeTab("Manus");
      } else if (fragmentTab === "thainguyen/xadonghy") {
        this.changeTab("Xadonghy");
      }   else if (fragmentTab === "thainguyen/xavotranh") {
        this.changeTab("Xavotranh");
      } else if (fragmentTab === "thainguyen/xathanhcong") {
        this.changeTab("Xathanhcong");
      } else if (fragmentTab === "thainguyen/xaankhanh") {
        this.changeTab("Xaankhanh");
      } else if (fragmentTab === "thainguyen/xadaiphuc") {
        this.changeTab("Xadaiphuc");
      } else if (fragmentTab === "thainguyen/xatancuong") {
        this.changeTab("Xatancuong");
      } else if (fragmentTab === "thainguyen/xaquanchu") {
        this.changeTab("Xaquanchu");
      } else if (fragmentTab === "thainguyen/xavanphu") {
        this.changeTab("Xavanphu");
      } else if (fragmentTab === "thainguyen/xatanthanh") {
        this.changeTab("Xatanthanh");
      } else if (fragmentTab === "thainguyen/xakhason") {
        this.changeTab("Xakhason");
      }
else if (fragmentTab === "thainguyen/hethongcnttthainguyen") {
        this.changeTab("hethongcnttthainguyen");
}
       else {
        // Nếu không phù hợp với bất kỳ tab nào, mặc định hiển thị tab gioiThieu
        this.changeTab("hethongcnttthainguyen");
      }
    }
  },
  created() {
    const savedLanguage = localStorage.getItem("languages");
    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
      window.location.reload();
    },

    async performPostRequest(id, section) {
      this.lang = localStorage.getItem("languages") || "vi";

      try {
        // Thực hiện POST request
        const response = await axios.post(apiChiTietBaiViet, {
          id: id,
          langId: "0",
        });
        if (this.lang === "vi") {
          this.base64 = response.data.result.content_vi;
          this.base64Title = response.data.result.title_vi;
        } else if (this.lang === "en") {
          this.base64 = response.data.result.content_en;
          this.base64Title = response.data.result.title_en;
        } else if (this.lang === "cn") {
          this.base64 = response.data.result.content_cn;
          this.base64Title = response.data.result.title_cn;
        } else if (this.lang === "kr") {
          this.base64 = response.data.result.content_kr;
          this.base64Title = response.data.result.title_kr;
        }

        var title = atob(this.base64Title);
        var decodedString = atob(this.base64);

        // Store separately for each section
        if (section === "Xatankhanh") {
          this.titleHtmlXatankhanh = decodeURIComponent(escape(title));
          this.contentHtmlXatankhanh = decodeURIComponent(escape(decodedString));
        } else if (section === "Xanamhoa") {
          this.titleHtmlXanamhoa = decodeURIComponent(escape(title));
          this.contentHtmlXanamhoa = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaphubinh") {
          this.titleHtmlXaphubinh = decodeURIComponent(escape(title));
          this.contentHtmlXaphubinh = decodeURIComponent(escape(decodedString));
        } else if (section === "Copilot") {
          this.titleHtmlCopilot = decodeURIComponent(escape(title));
          this.contentHtmlCopilot = decodeURIComponent(escape(decodedString));
        } else if (section === "Grok") {
          this.titleHtmlGrok = decodeURIComponent(escape(title));
          this.contentHtmlGrok = decodeURIComponent(escape(decodedString));
        } else if (section === "Xavanhan") {
          this.titleHtmlXavanhan = decodeURIComponent(escape(title));
          this.contentHtmlXavanhan = decodeURIComponent(escape(decodedString));
        } else if (section === "Manus") {
          this.titleHtmlManus = decodeURIComponent(escape(title));
          this.contentHtmlManus = decodeURIComponent(escape(decodedString));
        } else if (section === "Xadiemthuy") {
          this.titleHtmlXadiemthuy = decodeURIComponent(escape(title));
          this.contentHtmlXadiemthuy = decodeURIComponent(escape(decodedString));
        }
        else if (section === "Xadonghy") {
          this.titleHtmlXadonghy = decodeURIComponent(escape(title));
          this.contentHtmlXadonghy = decodeURIComponent(escape(decodedString));
        }
        else if (section === "Xavotranh") {
          this.titleHtmlXavotranh = decodeURIComponent(escape(title));
          this.contentHtmlXavotranh = decodeURIComponent(escape(decodedString));
        }else if (section === "UngDungAI") {
          this.titleHtmlUngDungAI = decodeURIComponent(escape(title));
          this.contentHtmlUngDungAI = decodeURIComponent(escape(decodedString));
        } else if (section === "Xathanhcong") {
          this.titleHtmlXathanhcong = decodeURIComponent(escape(title));
          this.contentHtmlXathanhcong = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaankhanh") {
          this.titleHtmlXaankhanh = decodeURIComponent(escape(title));
          this.contentHtmlXaankhanh = decodeURIComponent(escape(decodedString));
        } else if (section === "Xadaiphuc") {
          this.titleHtmlXadaiphuc = decodeURIComponent(escape(title));
          this.contentHtmlXadaiphuc = decodeURIComponent(escape(decodedString));
        } else if (section === "Xatancuong") {
          this.titleHtmlXatancuong = decodeURIComponent(escape(title));
          this.contentHtmlXatancuong = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaquanchu") {
          this.titleHtmlXaquanchu = decodeURIComponent(escape(title));
          this.contentHtmlXaquanchu = decodeURIComponent(escape(decodedString));
        } else if (section === "Xavanphu") {
          this.titleHtmlXavanphu = decodeURIComponent(escape(title));
          this.contentHtmlXavanphu = decodeURIComponent(escape(decodedString));
        } else if (section === "Xatanthanh") {
          this.titleHtmlXatanthanh = decodeURIComponent(escape(title));
          this.contentHtmlXatanthanh = decodeURIComponent(escape(decodedString));
        } else if (section === "Xakhason") {
          this.titleHtmlXakhason = decodeURIComponent(escape(title));
          this.contentHtmlXakhason = decodeURIComponent(escape(decodedString));
        }else if (section === "hethongcnttthainguyen") {
          this.titleHtmlHethongcnttthainguyen = decodeURIComponent(escape(title));
          this.contentHtmlHethongcnttthainguyen = decodeURIComponent(escape(decodedString));
       
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    changeTab(tab) {
      //   if (window.innerWidth <= 768) {
      //     this.isMenuVisible = false;
      //   }
      this.lang = localStorage.getItem("languages");

      const tabStates = {

        Xatankhanh: false, Xanamhoa: false, Xaphubinh: false, Copilot: false, ungDungAI: false,
        Xadiemthuy: false, xavanhan: false, Grok: false, Manus: false, Xadonghy: false, Xavotranh: false,
        Xathanhcong: false, Xaankhanh: false, Xadaiphuc: false, Xatancuong: false, Xaquanchu: false, Xavanphu: false, Xatanthanh: false, Xakhason: false,
        hethongcnttthainguyen: false,
      };

      this.performPostRequest(this.getPostId(tab), tab, this.lang);

      tabStates[tab] = true;
      this.activeTab = tab;
      this.showXatankhanh = tabStates.Xatankhanh;
      this.showXanamhoa = tabStates.Xanamhoa;
      this.showXaphubinh = tabStates.Xaphubinh;
      this.showCopilot = tabStates.Copilot;
      this.showGrok = tabStates.Grok;
      this.showXavanhan = tabStates.Xavanhan;
      this.showManus = tabStates.Manus;
      this.showXadiemthuy = tabStates.Xadiemthuy;
      this.showXadonghy = tabStates.Xadonghy;
      this.showXavotranh = tabStates.Xavotranh;
      this.showUngDungAI = tabStates.UngDungAI;
      this.showXathanhcong = tabStates.Xathanhcong;
      this.showXaankhanh = tabStates.Xaankhanh;
      this.showXadaiphuc = tabStates.Xadaiphuc;
      this.showXatancuong = tabStates.Xatancuong;
      this.showXaquanchu = tabStates.Xaquanchu;
      this.showXavanphu = tabStates.Xavanphu;
      this.showXatanthanh = tabStates.Xatanthanh;

      this.showXakhason = tabStates.Xakhason;
      this.showHethongcnttthainguyen = tabStates.hethongcnttthainguyen;

    },
    getPostId(tab) {
      // Sử dụng một đối tượng để ánh xạ tab với id của bài viết tương ứng
      const postIdMap = {

        Xatankhanh: "",
        Xanamhoa: "",
        Xaphubinh: "",
        Copilot: "",
        Grok: "",
        Xavanhan: "",
        Manus: "",
        Xadiemthuy: "",
        Xadonghy: "", 
        Xavotranh: "",        
        UngDungAI: "",   
        Xathanhcong: "",   
        Xaankhanh: "", 
        Xadaiphuc: "",  
        Xatancuong: "", 
        Xaquanchu: "",    
        Xavanphu: "",     
        Xatanthanh: "",   
        Xakhason: "",    
        hethongcnttthainguyen: "1758271376281vuBCn", 
      };

      return postIdMap[tab];
    },
  },
};
</script>

<style scoped>
.title-bai-viet {
  display: none;
}

.hiddentitle {
  display: none;
}
</style>
